import {Pathology} from '@legit-health/ui';

export default function isPsoriasis(pathology: Pathology) {
  return pathology.code === 'Psoriasis';
}
